var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecivedFileWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3451 5.345L12.9884 2.98833C12.6759 2.67583 12.2517 2.5 11.8101 2.5H5.83341C4.91258 2.5 4.16675 3.24583 4.16675 4.16667V15.8333C4.16675 16.7542 4.91258 17.5 5.83341 17.5H14.1667C15.0876 17.5 15.8334 16.7542 15.8334 15.8333V6.52333C15.8334 6.08167 15.6576 5.6575 15.3451 5.345V5.345Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 6.66667H12.5001C12.0401 6.66667 11.6667 6.29333 11.6667 5.83333V2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecivedFileWhite);
export default __webpack_public_path__ + "static/media/RecivedFileWhite.30d6064d95a9257684d8a07082fe1a00.svg";
export { ForwardRef as ReactComponent };